import Resource from '../../resource';
import request from '../../../utils/request';

class Slot extends Resource {
    constructor() {
        super('timeSlots');
    }
}

export {Slot as default};
